// Vendor imports
const { useSelector } = require('react-redux')
// Sibling imports
const selectors = require('./selectors')

function useIsLightweightCollectionSelectModalVisible() {
  return useSelector(selectors.isLightweightModalVisible)
}

module.exports = {
  useIsLightweightCollectionSelectModalVisible
}
